"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function ModelDownloadingProgress({ progress, modelName, }) {
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'ModelDownloadingProgress_Container', children: [(0, jsx_runtime_1.jsxs)(PercentLabel, { "data-e2e": 'ModelDownloadingProgress_PercentLabel', children: [progress, "%"] }), (0, jsx_runtime_1.jsx)(ui_1.ProgressBar, { value: progress, "data-e2e": 'ModelDownloadingProgress_ProgressBar' }), (0, jsx_runtime_1.jsx)(Preparing, { "data-e2e": 'ModelDownloadingProgress_Preparing', children: (0, i18n_1.Localized)(i18n_1.Strings.modelDownloading.preparing, { model: modelName }) })] }));
}
exports.default = ModelDownloadingProgress;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 250px;
`;
const PercentLabel = styled_components_1.default.div `
  font-size: 64px;
  font-weight: 300;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.text};
`;
const Preparing = styled_components_1.default.div `
  margin-top: 20px;
  font-size: 16px;
  color: ${({ theme }) => theme.text};
`;
